import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useLocation } from 'react-router';
import useFormValidation from '../hooks/useFormValidation';

import AuthLayout from '../components/AuthLayout';

import Button from '../components/inputs/Button';
import TextInput from '../components/inputs/TextInput';
import ThemeLink from '../components/ThemeLink';
import LoadingSpinner from '../components/LoadingSpinner';

import { validateEmailField } from '../helpers/validators';

export default function ForgotPassword() {
  const { resetpassword } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState(() => {
    const email = location.state?.email;
    return email || '';
  });
  const [error, setError] = useState();
  const [resetting, setResetting] = useState(false);
  const [resetSuccessful, setResetSuccessful] = useState();
  const [invalidFields, validatedFields, validateField, validateForm] =
    useFormValidation([{ name: 'email', validator: validateEmailField }]);

  function handleChangeEmail(e) {
    const { value } = e.target;
    setEmail(value);
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (validateForm({ email }, setError)) {
      setResetting(true);
      resetpassword(email)
        .then(() => {
          setResetSuccessful(true);
        })
        .catch((err) => {
          setError(err.message);
        })
        .finally(() => {
          setResetting(false);
        });
    }
  }

  return (
    <AuthLayout>
      {resetting && <LoadingSpinner message="Sending reset password link..." />}
      {!resetting && resetSuccessful && (
        <div className="text-center">
          <p className="mb-3">
            If there is an account associated with {email || 'that email'} you
            will have received a password reset link.
          </p>
          <p>
            Please check your inbox and follow the instructions to reset your
            password.
          </p>
          <p className="mt-14">
            Back to <ThemeLink to="/signin">Sign In</ThemeLink>
          </p>
        </div>
      )}
      {!resetting && resetSuccessful == null && (
        <form className="flex flex-col text-center" onSubmit={handleSubmit}>
          <h4>Forgot password?</h4>
          <p className="mb-8">
            Enter the email associated with your account and we will send you a
            password reset email.
          </p>
          <TextInput
            type="text"
            name="email"
            placeholder="Enter your email"
            value={email}
            onChange={handleChangeEmail}
            onBlur={() => {
              validateField('email', email, (err) => {
                setError(err);
              });
            }}
            validated={validatedFields.includes('email') || undefined}
            error={invalidFields.includes('email') || undefined}
          />
          {error && (
            <div className="mx-auto text-error mt-3 -mb-9">{error}</div>
          )}
          <Button
            className="mt-14 w-80 mx-auto"
            type="submit"
            primary
            disabled={invalidFields.length > 0}
          >
            Send Password Reset Email
          </Button>
          <p className="mt-2">
            Back to <ThemeLink to="/signin">Sign In</ThemeLink>
          </p>
        </form>
      )}
    </AuthLayout>
  );
}
